import { Component, OnInit, Input } from '@angular/core';
import { faTimes} from '@fortawesome/pro-light-svg-icons';
import { PresubmissionChecklistService } from 'src/app/shared/services/presubmission-checklist.service';
import { LettersService } from 'src/app/shared/services/letters.service';
import { CorrespondenceTimelineService } from 'src/app/shared/services/correspondence-timeline.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-presubmission-checklist',
  templateUrl: './presubmission-checklist.component.html',
  styleUrls: ['./presubmission-checklist.component.scss']
})
export class PresubmissionChecklistComponent implements OnInit {

  @Input() caseId: number = -1;

  faTimes = faTimes;

  generatingPDF: boolean = false;
  error: boolean = false;
  errorMessage: string = "";

  items: any [] = [];


  constructor(
              public presubmissionChecklistService: PresubmissionChecklistService,
              public lettersService: LettersService,
              public activeModal: NgbActiveModal,
              private correspondenceTimelineService: CorrespondenceTimelineService) {
  }

  ngOnInit(): void {
     // Get the items
      this.presubmissionChecklistService.getChecklistItemsForCase(this.caseId).subscribe((response : any) => {

        this.items = response.items;

      }, (error: any) => {

        this.error = true;
          if(error.status == 999)
          this.errorMessage = error.error;
        else if(error.status == 500 )
          this.errorMessage = "Internal Error";
        else
          this.errorMessage = error.statusText;
      });
  }

  generatePDF() {
    this.generatingPDF = true;
    this.lettersService.generatePreSubmissionChecklist(this.caseId).subscribe((response : any) => {

      this.activeModal.close(true);
      this.correspondenceTimelineService.refreshCaseTimeline.next();

    }, (error: any) => {
      this.generatingPDF = false;
      this.error = true;
      if(error.status == 999)
        this.errorMessage = error.error;
      else if(error.status == 500 )
        this.errorMessage = "Internal Error";
      else
        this.errorMessage = error.statusText;
    });  
  }

  updateValue(item: any){

    this.presubmissionChecklistService.updateItem(this.caseId, item.id, item.checklistResponseType).subscribe((response : any) => {


    }, (error: any) => {

      this.error = true;
      if(error.status == 999)
        this.errorMessage = error.error;
      else if(error.status == 500 )
        this.errorMessage = "Internal Error";
      else
        this.errorMessage = error.statusText;
    });
  }

  clearValue(item: any){
    item.checklistResponseType = null;
    this.updateValue(item);
  }

}
